import React from 'react';

const SIZE_CLASS = {
  sm: 'ads-skeleton--sm',
  md: '',
  lg: 'ads-skeleton--lg',
};

/**
 * ADS Skeleton — loading placeholders (Phase 5).
 */
export const AdsSkeleton = ({ className = '', width, height, circle = false }) => (
  <div
    className={['ads-skeleton', circle ? 'ads-skeleton--circle' : '', className].filter(Boolean).join(' ')}
    style={{
      width: width ?? undefined,
      height: height ?? undefined,
    }}
    aria-hidden
  />
);

export const AdsSkeletonBlock = ({ children, className = '', size = 'md' }) => (
  <div className={['ads-skeleton-block', SIZE_CLASS[size] || '', className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

export default AdsSkeleton;
